module.exports = __webpack_public_path__ + "95a011e858a065c5f0955e0183e2e7d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/calvert_research_and_management.png
// module id = 1642
// module chunks = 0